import { Link } from 'react-router-dom';
import page_lost from '../../assests/images/tick_image.jpg'

const ThankYouPage = () => {
    return (
        <section className="py-3" style={{ backgroundColor: '#fff', height: '100vh' }}>
            <div className="container">
                <div className="row pt-5">
                    <div className="col-12 mb-5">
                        <center>
                            <div className="thankyou-text">
                                <h1 className="main-heading">Thank You !</h1>
                                <h6 className="main-heading">You will received an email massage shortly.</h6>
                            <div className="thankyou-img">
                                <img src={page_lost} className="img-fluid" alt='' width='200' />
                            </div>
                                {/*<h6 className="main-heading">Check your Email</h6>*/}
                                {/*<sapn className="main-heading">If you didn't receive any email contact <span className='text-primary'>test@mail.com</span></sapn>*/}
                            </div>
                                <Link to="/" className="btn btn-primary text-white mt-3">
                                    Logout
                                </Link>
                        </center>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ThankYouPage;    